var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoupon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 19,
    fill: "#F8F8F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.30005 15.3976C9.30005 13.0793 11.1794 11.2 13.4977 11.2H24.1024C26.4207 11.2 28.3 13.0793 28.3 15.3976V16.4785C28.3 16.9783 27.9516 17.34 27.5747 17.4699C26.9674 17.6793 26.5326 18.256 26.5326 18.9325C26.5326 19.609 26.9674 20.1857 27.5747 20.3951C27.9516 20.525 28.3 20.8868 28.3 21.3866V22.4674C28.3 24.7857 26.4207 26.6651 24.1024 26.6651H13.4977C11.1794 26.6651 9.30005 24.7857 9.30005 22.4674V21.3866C9.30005 20.8868 9.64848 20.525 10.0254 20.3951C10.6327 20.1857 11.0675 19.609 11.0675 18.9325C11.0675 18.256 10.6327 17.6793 10.0254 17.4699C9.64848 17.34 9.30005 16.9783 9.30005 16.4785V15.3976ZM19.1991 15.926C18.9991 15.6611 18.6012 15.6611 18.4011 15.926L17.5829 17.0094C17.5231 17.0886 17.441 17.1482 17.3472 17.1806L16.064 17.624C15.7503 17.7324 15.6273 18.1108 15.8174 18.383L16.5949 19.4959C16.6518 19.5773 16.6831 19.6738 16.685 19.773L16.7101 21.1304C16.7163 21.4623 17.0382 21.6962 17.3557 21.5995L18.6545 21.2039C18.7494 21.175 18.8508 21.175 18.9458 21.2039L20.2446 21.5995C20.5621 21.6962 20.884 21.4623 20.8902 21.1304L20.9153 19.773C20.9171 19.6738 20.9485 19.5773 21.0053 19.4959L21.7829 18.383C21.973 18.1108 21.85 17.7324 21.5363 17.624L20.2531 17.1806C20.1592 17.1482 20.0772 17.0886 20.0173 17.0094L19.1991 15.926Z",
    fill: "#D5DAE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoupon);
export default __webpack_public_path__ + "static/media/coupon.f6fc99ce97eba7ad292ddf93834518a9.svg";
export { ForwardRef as ReactComponent };